import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-zap-fast',
  standalone: true,
  templateUrl: './rt-icon-zap-fast.component.html',
  styleUrls: ['./rt-icon-zap-fast.component.scss']
})
export class RtIconZapFastComponent {
  @Input() width: number | string = 22;
  @Input() height: number | string = 22;
}
